// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal-module--modal--2SNGh","modalCross":"modal-module--modal-cross--6TDg8","modalContent":"modal-module--modal-content--3ZKzw","zoom":"modal-module--zoom--1XO1S"};